import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setSession } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login", { replace: true }); return; }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const ref = sessionStorage.getItem("hv_ref") || undefined;
        const { data } = await api.post("/auth/google/session", { session_id, ref });
        sessionStorage.removeItem("hv_ref");
        setSession(data.user);
        window.history.replaceState({}, "", "/app/home");
        if (!data.user?.username_set) {
          nav("/setup-username", { replace: true });
        } else {
          nav("/app/home", { replace: true });
        }
      } catch (e) {
        console.error(e);
        nav("/login?error=oauth", { replace: true });
      }
    })();
  }, [nav, setSession]);

  return (
    <div className="min-h-screen bg-background grid place-items-center">
      <div className="font-display text-2xl text-neon-cyan pulse-glow">SIGNING YOU IN…</div>
    </div>
  );
}
